// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=staging` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  hostName: 'app.influencerprogram.com',
  apiHost: '//ws.getachoo.com',
  segmentToken: 'OC3SpoM8h2nyzrVebhkn0O7r2lsyzRf2',
  sentry: 'https://273c132fa9d54657abf6ee3a81b9eec6@sentry.io/1815632',
  iframeHost: '//ws.getachoo.com',
  intercomId: 'fkhiga69',
  pdfApiHost: 'https://pdf.getachoo.com',
  facebookAppId: '297074077851509',
  facebookScopes: 'instagram_basic,instagram_manage_insights,pages_show_list,pages_read_engagement,email,pages_manage_metadata,business_management',
  fbRedirectUri: 'https://ws.getachoo.com/auth/loginWithFacebook',
  authorizeChannelUri: 'https://ws.getachoo.com/channel/authorizeAchoo',
  fbAppState: 'prod',
  defaultLogin: 'influencer/login',
  signUpLink: 'https://www.getachoo.com/signup-v2/signup-new',
  newInfluencerPlatform: {
    isDisableSignUp: true,
    isDisableHomePage: true,
    isDisableChat: false,
    isDisableCampaign: false,
    marketingLink: 'https://www.getachoo.com'
  },
  featureFlags: {
    newCampaignFlow: true,
    isEnableCampaignHistory: true,
    isCampaignInfluencerDetails: false,
    isEnableBestPerformingInfluencerSorting: false,
    isRequestReview: false,
    isRedesignDemographic: false,
    isEnableChannelFollowers: false,
    discoverFollower: false,
    enableInfluencerReview: false
  },
  activePlatforms: [
    'blogs',
    'instagram',
    'youtube',
    'tiktok'
  ],
  defaultTimer: 15000,
  mmiLoginUrl: 'https://media.mmi-analytics.com/en/security/login',
  mmiLogoutUrl: 'https://media.mmi-analytics.com/en/security/logout',
  faqLink: 'https://getachoo.helpsite.com/',
  mmiHubSpotFormId: null,
  cbSite: 'achoo'
};

export const appVersion = '5.5.3-influencer';



// WEBPACK FOOTER //
// ./src/environments/environment.ts